//--- API ---//
/**
 * Función que obtiene la información de todas las dinámicas
 * @returns 
 */
const GetDynamics = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "Admin/getDynamics", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        const data = await response.json()
        
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

/**
 * Función que establece la sección o dinámica que se le debe mostrar al aficionado
 * @returns 
 */
const SetDynamic = async (idDynamic, triviaId = null) => {
    try {
        let urlToAPI = null
        let dataToSend = null
        let parameters = null
        let method = 'POST'

        switch (idDynamic) {
            case 1:
                urlToAPI = "Admin/SendWelcome"
                break

            case 2:
                urlToAPI = "Admin/SendWait"
                break

            case 3:
                urlToAPI = "Questions/getQuestionConfig"
                dataToSend = {
                    "id": 1,
                    "NumeroPreguntas": 7,
                    "TriviaId": triviaId
                }
                break

            case 4:
                urlToAPI = "Lottery/getLotteryConfig"
                dataToSend = {
                    "id": 1
                }
                break

            case 5:
                // urlToAPI = "Questions/getQuestionConfig"
                // dataToSend = {
                //     "id": 1,
                //     "NumeroPreguntas": 3
                // }
                break

            case 6:
                urlToAPI = "Colors/getColorsConfig"
                method = 'GET'
                break

            case 7:
                urlToAPI = "Admin/sendRecommendations"
                break

            case 8:
                urlToAPI = "Admin/sendThanks"
                break

            case 9:
                urlToAPI = "Admin/Balloons/Enter"
                break

            case 10:
                urlToAPI = "riddle/getConfig"
                dataToSend = {
                    "id": 1,
                    "quantityQuestions": 7
                }
                break

            case 12:
                urlToAPI = "Admin/SendSelfieFan"
                break

            case 13:
                urlToAPI = "QuizzWithImageAndOptions/getConfig"
                dataToSend = {
                    "id": 1,
                    "quantityQuestions": 7
                }
                break

            case 16:
                urlToAPI = "noisemeter/welcome"
                break

            case 18:
                urlToAPI = "Admin/sendQRMessages"
                break

            case 19:
                urlToAPI = "Admin/sendQRPluckingRooster"
                break

            case 21:
                urlToAPI = "Admin/rankingPluckingRooster"
                break

            case 22:
                urlToAPI = "Admin/displayFrontPageLuchoFest"
                break

            // case 23:
            //     urlToAPI = "Admin/lightshow/prepare"
            //     break
        
            default:
                urlToAPI = null
                break
        }

        if (urlToAPI) {
            if (dataToSend) {
                parameters = {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(dataToSend)
                }
            } else {
                parameters = {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            }
            
            const response = await fetch(process.env.REACT_APP_API_URL + urlToAPI, parameters)
            
            if (!response.ok) {
                // Manejar errores HTTP
                const errorData = await response.json()
                return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
            }
            
            if (idDynamic === 3 || idDynamic === 4 || idDynamic === 5 || idDynamic === 6 || idDynamic === 10 || idDynamic === 13) {
                const data = await response.json()
                
                // Retornar la respuesta exitosa
                return { success: true, data: data }
            } else {
                return { success: true, data: null }
            }
        } else {
            return { success: true, data: null }
        }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}
//--- API ---//

// //--- API ---//
// /**
//  * Función que obtiene la información de todas las dinámicas
//  * @returns 
//  */
// const GetDynamics = async () => {
//     try {
//         const response = await fetch(process.env.REACT_APP_API_URL + "Dynamics/getDynamics", {
//             method: 'GET',
//             headers: {
//                 'Content-Type': 'application/json',
//             }
//         })
        
//         if (!response.ok) {
//             // Manejar errores HTTP
//             const errorData = await response.json()
//             return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
//         }
        
//         const data = await response.json()
        
//         // Retornar la respuesta exitosa
//         return { success: true, data: data }
//     } catch (error) {
//         return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
//     }
// }

// const UpdateDynamic = async (idDynamic, field, value) => {
//     try {
//         debugger
//         const dataToSend = {
//             id: idDynamic,
//             field: field,
//             value: value
//         }
//         debugger
//         const response = await fetch(process.env.REACT_APP_API_URL + "Dynamics/updateOption", {
//             method: 'PATCH',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(dataToSend)
//         })
//         debugger
//         if (!response.ok) {
//             // Manejar errores HTTP
//             const errorData = await response.json()
//             return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
//         }
//         //debugger
//         //const data = await response.json()
//         debugger
//         // Retornar la respuesta exitosa
//         return { success: true, data: null }
//     } catch (error) {
        
//     }
// }
// //--- API ---//

export { GetDynamics, SetDynamic };